import { Layout, message } from "antd";
import { intersection } from "lodash-es";
import React, { useEffect, useState } from "react";
import { Outlet, ScrollRestoration, useBlocker, useRevalidator } from 'react-router-dom';
import { getNotifications } from "./api/auth/notifications.js";
import AuthManager from './auth-manager';
import { PushNotifications } from "./components/page";
import { Sidebar } from "./components/sidebar";
import { getUserSessionData, routesList, setUserSessionData } from "./library/constants";
import { isAnyDebouncePending } from "./library/helpers/global-debounce.js";
import { AuthProvider } from './providers/auth';

export default function AuthenticatedPage() {
  const [notifications, setNotifications] = useState([])
  const revalidator = useRevalidator()

  useEffect(() => {
    // Retrieve data from local storage on component mount
    console.log('fetching existing notifications....')
    setNotifications(getUserSessionData('NOTIFICATIONS'))
  }, [])

  // These user roles can later on come from the profile based on authentication
  const userRoles = JSON.parse(localStorage.getItem('USER'))?.permisions ?? [];
  // `hidden_if_allowed`: hide a menu entry when the user already has a fuller page for it
  // (e.g. marketing "Project" page is redundant for users with the full Project List).
  const routes = routesList.filter(
    (item) => intersection(item.roles_allowed, userRoles).length > 0/*  || true */
      && intersection(item.hidden_if_allowed ?? [], userRoles).length === 0
  );

  const updateNotifications = async () => {
    const { notifications, unreadCount } = await getNotifications()
    revalidator.revalidate()
    setUserSessionData('NOTIFICATIONS', JSON.stringify({ notifications, unreadCount }))
    setNotifications({ notifications, unreadCount })
  }

  // Block navigation if debouncing
  useBlocker(() => {
    if (isAnyDebouncePending()) {
      message.warning('Changes are being saved. Please wait a moment before leaving!')
      return true
    }
    return false
  });

  return (
    <AuthProvider>
      <ScrollRestoration />
      <AuthManager>
        <>
          <PushNotifications onNewNotifaction={updateNotifications} />
          <Layout hasSider style={{ backgroundColor: '#f3f2f7', alignItems: 'flex-start' }}>
            <Sidebar routes={routes} />
            <Layout.Content style={{ position: 'relative' }}>
              <Outlet context={{ ...notifications, updateNotifications }} />
            </Layout.Content>
          </Layout>
        </>
      </AuthManager>
    </AuthProvider>
  );
}
